import { NgModule } from '@angular/core';
import { GuideBotComponent } from './guide-bot.component';
import { AiModule } from '../ai/ai.module';
import { CommonModule } from '@angular/common';

@NgModule({
    declarations: [GuideBotComponent],
    exports: [GuideBotComponent],
    imports: [AiModule, CommonModule],
})
export class GuideBotModule {}
